mutation RestoreConfigs($ids: [ID!]!) {
  restoreConfigs(ids: $ids) {
    id
    deletedAt
  }
}
